import styled from 'vue-styled-components'

const tableTitle = styled.h4`
    text-align: center;
    text-decoration: underline;
    font-size: 15px;
    font-weight: 600;
    line-height: 18px;
`

export default tableTitle